import { useCallback, useRef } from "react";

function useDebounceCallback(callback: () => void, delay: number) {
  const debounceTimeout = useRef<number | null>(null);

  const debouncedCallback = useCallback(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = window.setTimeout(() => {
      callback();
    }, delay);
  }, [callback, delay]);

  return debouncedCallback;
}

export default useDebounceCallback;
